function trimString(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
}

export function buildWorkspaceIdentity(env = import.meta.env) {
  const workspaceName = trimString(env.VITE_WORKSPACE_NAME);
  const enabled = Boolean(env.DEV && workspaceName);

  return {
    enabled,
    workspaceName,
  };
}

export function formatWorkspaceDocumentTitle(baseTitle, identity = workspaceIdentity) {
  const resolvedBaseTitle = trimString(baseTitle) || 'Modul';
  if (!identity?.enabled) {
    return resolvedBaseTitle;
  }

  return `${identity.workspaceName} | ${resolvedBaseTitle}`;
}

export const workspaceIdentity = buildWorkspaceIdentity();
